import { OrganisationConfigItem } from '@futrli-sdk/consolidations';
import { OrganisationListItem } from '@futrli-sdk/workspaces';

import { FetchConsolidationOrganisationInfoResult } from '../queries/consolidations';
import { FetchWorkspacesListingResult } from '../operations/workspaces/queries/workspacesListingQuery';

export interface CombinedConsolidationOrganisationData extends OrganisationListItem, OrganisationConfigItem {}

/**
 * Combines the organisations for a workspace with the extra consolidation-related organisation data
 * @param workspaceListing - the result of the workspace listing query
 * @param consolidationOrganisationInfo - the result of the consolidation organisation info query
 * @param workspaceId - the id of the workspace to get the organisations from
 */
export const consolidationOrganisationDataCombiner = (
  workspaceListing: FetchWorkspacesListingResult | undefined,
  consolidationOrganisationInfo: FetchConsolidationOrganisationInfoResult | undefined,
  workspaceId: string
) => {
  if (!workspaceListing || !consolidationOrganisationInfo) {
    return undefined;
  }

  const workspace = workspaceListing.find(w => w.id === workspaceId);

  if (workspace) {
    const output: Record<string, CombinedConsolidationOrganisationData> = {};
    workspace.organisations.forEach(org => {
      const extra = consolidationOrganisationInfo.find(info => info.id === org.id) || ({} as OrganisationConfigItem);
      output[org.id] = {
        ...org,
        ...extra,
        name: extra.name || org.name,
        can_be_added_to_consolidation: extra.id ? extra.can_be_added_to_consolidation : false
      };
    });
    return output;
  }
};
